var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAjaxLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 124.46 162.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8c96a1;}.cls-2{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill-rule:evenodd;stroke:#0c4c75;stroke-width:.5px;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 51.55,
    y1: 120.81,
    x2: 51.55,
    y2: 0.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1b81c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 72.91,
    y1: 161.01,
    x2: 72.91,
    y2: 40.82,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.09,42.45l-32.56,32.03,11.21,10.14,10.6-10.66h1.18v61.16c0,7.76-6.25,14.01-14.01,14.01h-11.13c-7.76,0-14.01-6.25-14.01-14.01v-6.53h-21.65v8.13c0,14.04,11.3,25.34,25.34,25.34h28.77c14.04,0,25.34-11.3,25.34-25.34v-62.71h.84s12.39,10.62,12.39,10.62l9.74-10.14-32.03-32.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.38,121.85l32.56-32.03-11.21-10.14-10.6,10.66h-1.18V29.19c0-7.76,6.25-14.01,14.01-14.01h11.13c7.76,0,14.01,6.25,14.01,14.01v6.53h21.65v-8.13c0-14.04-11.3-25.34-25.34-25.34h-28.77c-14.04,0-25.34,11.3-25.34,25.34v62.71h-.84s-12.39-10.62-12.39-10.62L.35,89.83l32.03,32.03h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m48.65.25c-14.04,0-25.34,11.3-25.34,25.34v62.71h-.84s-12.39-10.62-12.39-10.62L.35,87.83l32.03,32.03,32.56-32.03-11.21-10.14-10.6,10.66h-1.18V27.19c0-7.76,6.25-14.01,14.01-14.01h11.13c7.76,0,14.01,6.25,14.01,14.01v6.53h21.65v-8.13c0-14.04-11.3-25.34-25.34-25.34h-28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.09,40.45l-32.56,32.03,11.21,10.14,10.6-10.66h1.18v61.16c0,7.76-6.25,14.01-14.01,14.01h-11.13c-7.76,0-14.01-6.25-14.01-14.01v-6.53h-21.65v8.13c0,14.04,11.3,25.34,25.34,25.34h28.77c14.04,0,25.34-11.3,25.34-25.34v-62.71h.84s12.39,10.62,12.39,10.62l9.74-10.14-32.03-32.03h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjaxLogo);
export default __webpack_public_path__ + "static/media/ajaxLogo.3c982a3a9adac3b4865defe100d9c350.svg";
export { ForwardRef as ReactComponent };